(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  
      const faqs = document.querySelectorAll(".accordian");
      for (const item of faqs) {
        const curr_faq = item.childNodes;
        const question = curr_faq[1];
        const answer = curr_faq[3];
        const icon = question.querySelector(".symbol");
        icon.addEventListener("click", function () {
          answer.classList.toggle("nothing");
          const i = icon.querySelector("i");
          i.classList.toggle("fa-minus");
          i.classList.toggle("fa-plus");
          console.log(i);
        });
      }
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  window.onscroll = function() {myFunction()};

var header = document.getElementById("myHeader");

var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-footer"] && !Shopify.designMode) return;
  try {
    
  
      const faqs = document.querySelectorAll(".faq");
      for (const item of faqs) {
        const curr_faq = item.childNodes;
        const question = curr_faq[1];
        const answer = curr_faq[3];
        const icon = question.querySelector(".icon-main");
        icon.addEventListener("click", function () {
          answer.classList.toggle("non-active");
          const i = icon.querySelector("i");
          i.classList.toggle("fa-minus");
          i.classList.toggle("fa-plus");
          console.log(i);
        });
      }
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  const faqs = document.querySelectorAll(".faq"); 
for (const item of faqs) { 
  const curr_faq = item.childNodes; 
  const question = curr_faq[1]; 
  const answer = curr_faq[3]; 
  const icon = question.querySelector(".icon-main"); 
  icon.addEventListener("click", function () { 
    answer.classList.toggle("non-active"); 
    const i = icon.querySelector("i"); 
    i.classList.toggle("fa-minus"); 
    i.classList.toggle("fa-plus"); 
    console.log(i); 
  }); 
} 

  } catch(e) { console.error(e); }
})();
})();
